import { Box, Paper, Typography } from '@mui/material';

const promoterLogo = '/assets/footer-logos-svg/2.svg';
const projectLogo = '/assets/footer-logos-svg/1.png';
const investorLogos = [
    '/assets/footer-logos-svg/3.svg',
    '/assets/footer-logos-svg/4.svg',
    '/assets/footer-logos-svg/5.png',
    '/assets/footer-logos-svg/6.png',
    '/assets/footer-logos-svg/7.png',
    '/assets/footer-logos-svg/8.png',
    '/assets/footer-logos-svg/9.svg'
];
const cofinancedLogo = '/assets/footer-logos-svg/10.svg';

const DashboardFooter = ({ compact = false, authMode = false, backgroundColor = '#EEEEEE' }) => {
    return (
        <Paper
            sx={{
                px: authMode ? { xs: 1.25, md: 1.75 } : compact ? { xs: 1.5, md: 2 } : { xs: 2, md: 3.5 },
                py: authMode ? { xs: 1.1, md: 1.35 } : compact ? { xs: 1.9, md: 1.8 } : { xs: 2.5, md: 2.3 },
                bgcolor: backgroundColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: authMode ? { xs: 1, md: 1.4 } : compact ? { xs: 1.5, md: 2 } : { xs: 2, md: 3.5 },
                borderRadius: 0,
                border: 'none',
                boxShadow: 'none',
                flexWrap: authMode ? 'nowrap' : { xs: 'wrap', xl: 'nowrap' },
                overflow: 'hidden'
            }}
        >
            <Box
                component="img"
                src={projectLogo}
                alt="Info.cuidador 2.0"
                sx={{
                    width: authMode ? { xs: 34, md: 46 } : compact ? { xs: 48, md: 58 } : { xs: 62, md: 78 },
                    height: 'auto',
                    objectFit: 'contain',
                    flexShrink: 0
                }}
            />

            <Box
                sx={{
                    position: 'relative',
                    minWidth: authMode ? { md: 140 } : compact ? { md: 170 } : { md: 220 },
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: authMode ? { xs: 32, md: 40 } : compact ? { xs: 42, md: 48 } : { xs: 54, md: 64 },
                    flexShrink: 0
                }}
            >
                <Typography
                    sx={{
                        position: 'absolute',
                        left: 0,
                        top: authMode ? { xs: -10, md: -12 } : compact ? { xs: -12, md: -14 } : { xs: -14, md: -16 },
                        fontSize: authMode ? '0.72rem' : compact ? '0.82rem' : '0.95rem',
                        color: '#3D3D3D',
                        fontWeight: 700,
                        textAlign: 'left'
                    }}
                >
                    Entidade Promotora:
                </Typography>
                <Box
                    component="img"
                    src={promoterLogo}
                    alt="Entidade Promotora"
                    sx={{
                        width: authMode ? { xs: 110, md: 150 } : compact ? { xs: 150, md: 180 } : { xs: 180, md: 230 },
                        maxWidth: '100%',
                        height: 'auto',
                        objectFit: 'contain'
                    }}
                />
            </Box>

            <Box
                sx={{
                    position: 'relative',
                    flex: 1,
                    minWidth: authMode ? 0 : { xs: '100%', xl: 0 },
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: authMode ? { xs: 32, md: 40 } : compact ? { xs: 42, md: 48 } : { xs: 54, md: 64 }
                }}
            >
                <Typography
                    sx={{
                        position: 'absolute',
                        left: 0,
                        top: authMode ? { xs: -10, md: -12 } : compact ? { xs: -12, md: -14 } : { xs: -14, md: -16 },
                        fontSize: authMode ? '0.72rem' : compact ? '0.82rem' : '0.95rem',
                        color: '#3D3D3D',
                        fontWeight: 700,
                        textAlign: 'left'
                    }}
                >
                    Investidores Sociais:
                </Typography>
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: 'repeat(3, minmax(78px, 1fr))',
                            md: authMode ? 'repeat(7, minmax(52px, 1fr))' : compact ? 'repeat(7, minmax(70px, 1fr))' : 'repeat(7, minmax(86px, 1fr))'
                        },
                        gap: authMode ? { xs: 0.55, md: 0.75 } : compact ? { xs: 0.8, md: 1 } : { xs: 1, md: 1.4 },
                        alignItems: 'center',
                        width: '100%'
                    }}
                >
                    {investorLogos.map((src, index) => (
                        <Box
                            key={src}
                            component="img"
                            src={src}
                            alt={`Investidor Social ${index + 1}`}
                            sx={{
                                width: '100%',
                                maxHeight: authMode ? { xs: 20, md: 28 } : compact ? { xs: 32, md: 38 } : { xs: 38, md: 50 },
                                objectFit: 'contain',
                                justifySelf: 'center'
                            }}
                        />
                    ))}
                </Box>
            </Box>

            <Box
                sx={{
                    position: 'relative',
                    minWidth: authMode ? { md: 150 } : compact ? { md: 180 } : { md: 220 },
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: authMode ? { xs: 32, md: 40 } : compact ? { xs: 42, md: 48 } : { xs: 54, md: 64 },
                    flexShrink: 0
                }}
            >
                <Typography
                    sx={{
                        position: 'absolute',
                        left: 0,
                        top: authMode ? { xs: -10, md: -12 } : compact ? { xs: -12, md: -14 } : { xs: -14, md: -16 },
                        fontSize: authMode ? '0.72rem' : compact ? '0.82rem' : '0.95rem',
                        color: '#3D3D3D',
                        fontWeight: 700,
                        textAlign: 'left'
                    }}
                >
                    Cofinanciado:
                </Typography>
                <Box
                    component="img"
                    src={cofinancedLogo}
                    alt="Cofinanciado"
                    sx={{
                        width: authMode ? { xs: 140, md: 190 } : compact ? { xs: 180, md: 220 } : { xs: 210, md: 300 },
                        maxWidth: '100%',
                        height: 'auto',
                        objectFit: 'contain',
                        alignSelf: 'center'
                    }}
                />
            </Box>
        </Paper>
    );
};

export default DashboardFooter;
